import { DefaultApiGetWritebackRunsRequest } from "@coeff/api-admin-ext";
import React from "react";

import { FlexRow } from "../../../components";
import { ExportCSVButton } from "../../WorkspaceAdmin/ExportCSVButton";
import { TabName } from "../../WorkspaceAdmin/WorkspaceAdmin";
import { TableFilters } from "../useTableFilters";

import { DebouncedSearchInput } from "./DebouncedSearchInput";
import {
  DataSourceFilterPopover,
  RunStatusFilterPopover,
  TriggerFilterPopover,
  UserFilterPopover,
} from "./FilterPopovers";

type Props = {
  domain: string;
  search: string;
  onSearchChange: (search: string) => void;
  filters: TableFilters<keyof DefaultApiGetWritebackRunsRequest>;
  setFilters: (filters: TableFilters<keyof DefaultApiGetWritebackRunsRequest>) => void;
};

export const WritebackRunsFilterToolbar: React.FC<Props> = ({
  domain,
  onSearchChange,
  search,
  filters,
  setFilters,
}) => {
  return (
    <FlexRow style={{ justifyContent: "space-between" }}>
      <FlexRow style={{ flex: 1 }}>
        <DebouncedSearchInput initialSearch={search} onChange={onSearchChange} />
      </FlexRow>

      <FlexRow>
        <DataSourceFilterPopover
          table="writebacks"
          domain={domain}
          entityLabel="Destination"
          values={filters.data_source_type}
          onChange={values =>
            setFilters({
              ...filters,
              data_source_type: values,
            })
          }
        />

        <UserFilterPopover
          table="writebacks"
          domain={domain}
          values={filters.user_id}
          onChange={values =>
            setFilters({
              ...filters,
              user_id: values,
            })
          }
        />

        <RunStatusFilterPopover
          values={filters.status}
          onChange={values =>
            setFilters({
              ...filters,
              status: values,
            })
          }
        />

        <TriggerFilterPopover
          values={filters.trigger}
          onChange={values =>
            setFilters({
              ...filters,
              trigger: values,
            })
          }
        />

        <ExportCSVButton tab={TabName.writeback_runs} />
      </FlexRow>
    </FlexRow>
  );
};
